export enum authTypes {
  CHECK_AUTH_REQUEST = 'CHECK_AUTH_REQUEST',
  FETCH_AUTH_REQUEST = 'FETCH_AUTH_REQUEST',
  FETCH_AUTH_SUCCESS = 'FETCH_AUTH_SUCCESS',
  FETCH_AUTH_FAILURE = 'FETCH_AUTH_FAILURE',
  LOGOUT_REQUEST = 'FETCH_AUTH_FAILURE',
}
